import $ from 'jquery';
import './hero-text-slider';
import './testimonials-slider';
import './calc-from-site';
import './accordion';
import './popup';